import styled from 'styled-components'
import { SIZES } from '../../../constants'

export default styled.span`
  font-size: 16px;
  line-height: 20px;
  display: block;
  height: 64px;
  overflow: hidden;

  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    height: 102px;
  }
`
